import {RECORD_ACTIVITY, RESET_TIMEOUT} from 'ducks/SessionActivity';
import getStore from 'store';

const actionsToSync = [RECORD_ACTIVITY, RESET_TIMEOUT];
const broadcastChannel = new BroadcastChannel('amica/syncReduxBetweenTabs');

broadcastChannel.onmessage = (event) => {
  try {
    getStore().dispatch({...event.data, suppressSync: true}); //suppressSync prevents triggering a new broadcast from actions that were originally triggered by a broadcast
  } catch (e) {
    //ignore sync requests if the store isn't initialized yet
  }
};

/**
 * This middleware will listen for messages that should be relayed to other open ADC tabs and broadcast them
 * to be consumed. At the moment this is only used for session activity to prevent background tabs from logging
 * out the user unexpectedly. Given our initiative to roll off from redux and multi-tab operations on our site not being
 * something we necessarily want to encourage, I'm hard pressed to think of where else this would actually be used
 */
const syncReduxBetweenTabs =
  () =>
  (next: (action: {type: string; suppressSync?: boolean}) => object) =>
  (action: {type: string; suppressSync?: boolean}) => {
    const result = next(action);

    if (!action.suppressSync && actionsToSync.includes(action.type)) {
      broadcastChannel.postMessage(action);
    }

    return result;
  };

export default syncReduxBetweenTabs;
